import React, { useEffect, useRef, memo } from "react";
import { Chart } from "chart.js/auto";

const SharedBarChart = memo(({
  periodResult,
  firstLabel = "نسبة الحضور %",
  secondLabel = "نسبة الغياب %",
  firstColor = "rgba(40, 167, 69, 0.8)",
  secondColor = "rgba(220, 53, 69, 0.8)",
  firstBorderColor = "rgba(40, 167, 69, 1)",
  secondBorderColor = "rgba(220, 53, 69, 1)",
  title = "الرسم البياني للنسب"
}) => {
  const canvasRef = useRef(null);
  const chartInstanceRef = useRef(null);

  useEffect(() => {
    if (!canvasRef.current) return;

    if (chartInstanceRef.current) {
      chartInstanceRef.current.destroy();
    }

    chartInstanceRef.current = new Chart(canvasRef.current, {
      type: 'bar',
      data: {
        labels: periodResult.periods.map((p) => p.name),
        datasets: [
          {
            label: firstLabel,
            data: periodResult.periods.map((p) => parseFloat(p.attendancePercentage)),
            backgroundColor: firstColor,
            borderColor: firstBorderColor,
            borderWidth: 2,
          },
          {
            label: secondLabel,
            data: periodResult.periods.map((p) => parseFloat(p.absencePercentage)),
            backgroundColor: secondColor,
            borderColor: secondBorderColor,
            borderWidth: 2,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            position: "top",
            labels: {
              font: { size: 14, family: "Arial" },
              padding: 15,
              usePointStyle: true,
            },
          },
          tooltip: {
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            titleFont: { size: 14 },
            bodyFont: { size: 13 },
            padding: 12,
            callbacks: {
              label: (context) => 
                `${context.dataset.label}: ${context.parsed.y.toFixed(2)}%`,
            },
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            max: 100,
            grid: { color: "rgba(0, 0, 0, 0.1)" },
            ticks: {
              font: { size: 12 },
              callback: (value) => value + "%",
            },
          },
          x: {
            grid: { display: false },
            ticks: { font: { size: 12 } },
          },
        },
        barThickness: 40,
        categoryPercentage: 0.8,
      }
    });

    return () => {
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
      }
    };
  }, [periodResult, firstLabel, secondLabel, firstColor, secondColor, firstBorderColor, secondBorderColor]);

  return (
    <div style={{ 
      marginTop: "30px", 
      padding: "20px", 
      backgroundColor: "#f8f9fa", 
      borderRadius: "8px" 
    }}>
      <h3 style={{ 
        fontSize: "16px", 
        textAlign: "center", 
        marginBottom: "20px" 
      }}>
        <b>{title}</b>
      </h3>
      <div style={{ maxWidth: "700px", margin: "0 auto" }}>
        <canvas ref={canvasRef}></canvas>
      </div>
    </div>
  );
});

SharedBarChart.displayName = "SharedBarChart";

export default SharedBarChart;